var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
//@ts-ignore
import { Modal as LibModal } from 'react-overlays';
import * as baobab from '@data/baobab/baobab';
//@ts-ignore
import { useRoot } from 'baobab-react/hooks';
import Manager from './Manager';
var modalStyle = {
    zIndex: 1040,
    position: 'fixed',
    top: 0,
    display: 'flex',
    width: '100%',
    height: '100%',
    padding: '20px',
    flex: 1,
    pointerEvents: 'none',
    borderRadius: 10,
};
var backdropStyle = {
    zIndex: 1040,
    backgroundColor: '#000',
    opacity: 0.5,
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
};
var renderBackdrop = function (props) { return React.createElement("div", __assign({}, props, { style: backdropStyle })); };
var dialogStyle = function (w, h, mT) {
    var width = w ? "".concat(w, "px") : 'auto';
    var height = h ? h : 'auto';
    var margTop = mT ? mT : 'auto';
    return {
        width: width,
        height: height,
        marginTop: margTop,
        pointerEvents: 'all',
    };
};
export default function Modal(props) {
    var _a = __read(useState(true), 2), showing = _a[0], setShowing = _a[1];
    function close() {
        if (props.closeable) {
            setShowing(false);
            Manager.closeModal();
        }
    }
    var Root = useRoot(baobab.root);
    return (React.createElement(Root, null,
        React.createElement(LibModal, { "aria-labelledby": "modal", style: modalStyle, renderBackdrop: renderBackdrop, show: showing, onHide: close, keyboard: props.closeable },
            React.createElement("div", { className: "fs-modal-content", style: dialogStyle(props.width, props.height, props.marginTop) }, props.children))));
}
